export const OPERATORS_TO_TEXT = {
    is: "is",
    is_any: "is one of",
    is_not: "is not",
    is_not_any: "is not one of",
    all_of: "all of",
    before: "before",
    after: "after",
};
export const isMultipleOperator = (operator) => {
    const multiOperators = ["is_any", "is_not_any", "all_of"];
    return multiOperators.includes(operator);
};
export const isValueSelected = (value) => value.length > 0;
//# sourceMappingURL=utils.js.map